var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { JSONStruct, property } from 'badphraim/data/JSONStruct';
export class ewMemberContractResult extends JSONStruct {
    constructor() {
        super(...arguments);
        /** @override */ this.contractId = 0;
        /** @override */ this.invoiceId = 0;
        /** @override */ this.link_to_nets = '';
        /** @override */ this.memberId = 0;
        /** @override */ this.ownerId = 0;
    }
}
__decorate([
    property,
    __metadata("design:type", Number)
], ewMemberContractResult.prototype, "contractId", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], ewMemberContractResult.prototype, "invoiceId", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewMemberContractResult.prototype, "link_to_nets", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], ewMemberContractResult.prototype, "memberId", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], ewMemberContractResult.prototype, "ownerId", void 0);
